import { render, staticRenderFns } from "./InvitationLoading.vue?vue&type=template&id=64bd478a&scoped=true"
import script from "./InvitationLoading.vue?vue&type=script&lang=js"
export * from "./InvitationLoading.vue?vue&type=script&lang=js"
import style0 from "./InvitationLoading.vue?vue&type=style&index=0&id=64bd478a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd478a",
  null
  
)

export default component.exports